const login = () => import(/* webpackPrefetch: true */ '@/views/public/index.vue')
const login_pegawai = () => import(/* webpackPrefetch: true */ '@/views/public/login-pegawai.vue')
const routes = [
  {
    path: "/login",
    name: "Admin Login",
    component: login,
    meta: {
      title: "Admin Login"
    }
  },

  {
    path: "/login-pegawai",
    name: "Login Pegawai",
    component: login_pegawai,
    meta: {
      title: "Login Pegawai"
    }
  },
]
export default routes.map(route => {
  const meta = {
    all: false, 
    public: true,
    onlyLoggedOut: true,
    title: route.meta.title
  }
  return { ...route, meta }
})